import React from 'react';
import { styled } from '@ff/ui';
import Box, { BoxProps } from '@ff/ui/Box';
import isVideo from 'shared/lib/isVideo';
import isImage from 'shared/lib/isImage';
import _ from 'shared/lib/gettext';

interface Props extends BoxProps {
  name: string;
  isSelected: boolean;
  // Still being replaced by its compressed copy: shown, but not pickable.
  converting?: boolean;
}

export default function Asset(props: Props) {
  const { name, onClick, isSelected, converting } = props;

  return (
    <Container
      onClick={onClick}
      isSelected={isSelected}
      converting={converting}
      aria-busy={converting || undefined}
    >
      <i className="material-icons">{converting ? 'hourglass_empty' : getAssetIcon(name)}</i>
      {name}
      {converting && ` (${_('ASSET_OPTIMIZING')})`}
    </Container>
  );
}

const Container = styled(Box)<{ isSelected?: boolean, converting?: boolean }>(({ isSelected, converting }) => ({
  display: 'flex',
  alignItems: 'center',
  fontStyle: isSelected ? 'italic' : 'normal',
  fontWeight: isSelected ? 'bold' : 'normal',
  ...(converting && { opacity: 0.5, cursor: 'progress' }),
}));

export const getAssetIcon = (filename: string) => {
  if (isVideo(filename)) {
    return 'movie';
  }

  if (isImage(filename)) {
    return 'image';
  }

  // Default to generic file icon
  return 'insert_drive_file';
};
